"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnOkType = exports.ModalType = exports.ErrorType = exports.ErrorCode = exports.ServerErrorCode = void 0;
var ServerErrorCode;
(function (ServerErrorCode) {
    // The node server exception is 5 digits, and the java server exception is 3~4 digits
    ServerErrorCode[ServerErrorCode["ServerError"] = 50000] = "ServerError";
    ServerErrorCode[ServerErrorCode["Deny"] = 50001] = "Deny";
    ServerErrorCode[ServerErrorCode["Reject"] = 50002] = "Reject";
    ServerErrorCode[ServerErrorCode["BaseRevisionMaxExceed"] = 50003] = "BaseRevisionMaxExceed";
    ServerErrorCode[ServerErrorCode["BaseRevisionDiffExceed"] = 50004] = "BaseRevisionDiffExceed";
    ServerErrorCode[ServerErrorCode["ChangesetLengthError"] = 50005] = "ChangesetLengthError";
    ServerErrorCode[ServerErrorCode["MetaApplyError"] = 50006] = "MetaApplyError";
    ServerErrorCode[ServerErrorCode["NoRoom"] = 50007] = "NoRoom";
    ServerErrorCode[ServerErrorCode["MessageDuplicate"] = 423] = "MessageDuplicate";
})(ServerErrorCode = exports.ServerErrorCode || (exports.ServerErrorCode = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["NoError"] = "F0000";
    ErrorCode["Unknown"] = "F0001";
    ErrorCode["TableDeleted"] = "F0002";
    ErrorCode["RecordDeleted"] = "F0003";
    ErrorCode["FieldDeleted"] = "F0004";
    ErrorCode["ViewDeleted"] = "F0005";
    ErrorCode["SaveError"] = "F0006";
    ErrorCode["RequestTimeout"] = "F1001";
    ErrorCode["ResponseInvalidMessage"] = "F2001";
    ErrorCode["ResponseUnexpectedResponse"] = "F2002";
    ErrorCode["InvalidOperation"] = "F3001";
    ErrorCode["CommandExecuteFailed"] = "F3002";
    ErrorCode["CollaFollowRejected"] = "F3003";
    ErrorCode["EngineCreateFailed"] = "F3004";
    /**
     * The difference between the local document version and the latest server version exceeds the threshold
     */
    ErrorCode["CollaRevGap"] = "F3005";
    ErrorCode["CollaSyncError"] = "F3006";
    ErrorCode["CollaModalError"] = "F3007";
    ErrorCode["ModelInvalidJSON"] = "F4001";
    /**
     * Type error codes are not supported
     */
    ErrorCode["NotSupportAction"] = "F5001";
    /**
     * Insufficient permissions
     */
    ErrorCode["PermissionDenied"] = "F6001";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
var ErrorType;
(function (ErrorType) {
    /**
     * unknown mistake
     */
    ErrorType["UnknownError"] = "Error.Unknown";
    ErrorType["Warning"] = "Error.Warning";
    /**
     * An error occurred while requesting
     */
    ErrorType["RequestError"] = "Error.Request";
    /**
     * Error responding to request
     */
    ErrorType["ResponseError"] = "Error.Response";
    /**
     * Collaboration error
     */
    ErrorType["CollaError"] = "Error.Colla";
    /**
     * data error
     */
    ErrorType["ModelError"] = "Error.Model";
    /**
     * Error returned by the server
     */
    ErrorType["ServerError"] = "Error.Sever";
    /**
     * Unsupported Action
     */
    ErrorType["NotSupportError"] = "Error.NotSupport";
    /**
     * Insufficient permissions
     */
    ErrorType["PermissionDeniedError"] = "Error.PermissionDenied";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var ModalType;
(function (ModalType) {
    ModalType["Error"] = "error";
    ModalType["Success"] = "success";
    ModalType["Warning"] = "warning";
    ModalType["Info"] = "info";
})(ModalType = exports.ModalType || (exports.ModalType = {}));
var OnOkType;
(function (OnOkType) {
    OnOkType["Refresh"] = "Refresh";
    OnOkType["BackWorkBench"] = "BackWorkBranch";
})(OnOkType = exports.OnOkType || (exports.OnOkType = {}));
//# sourceMappingURL=error_types.js.map